// extracted by css-extract-rspack-plugin
export default {"a0":"ToolsMenu-cls1_mkB","a1":"ToolsMenu-cls1_mkB","cls1":"ToolsMenu-cls1_nYL","cls2":"ToolsMenu-cls2_88T ToolsMenu-cls1_nYL"};